import React from 'react';
import PropTypes from 'prop-types';
import { useClassName } from '@travpro/hooks';

const Badge = ({ badgeImg, title = '', status = false, lockLinkUrl = '', onClick = () => {} }) => {
  const c = useClassName('badge');

  const handleClick = (e) => {
    // If there's a lockLinkUrl and the badge is not active, don't trigger the onClick
    if (!status && lockLinkUrl?.length > 0) {
      return;
    }
    onClick(e);
  };

  return (
    <div {...c()} onClick={handleClick} style={{ cursor: 'pointer' }}>
      <div {...c('container')}>
        <div {...c('inner')}>
          <img {...c('image', { inactive: !status })} src={badgeImg} alt={title} />
        </div>

        {!status && !lockLinkUrl?.length > 0 && (
          <div {...c('lock')}>{/* <FontAwesomeIcon className={'icon'} icon={['fas', 'lock']} size="6x" /> */}</div>
        )}

        {!status && lockLinkUrl?.length > 0 && (
          <a href={lockLinkUrl} onClick={(e) => e.stopPropagation()}>
            <div {...c('lock')}>{/* <FontAwesomeIcon className={'icon'} icon={['fas', 'lock']} size="6x" /> */}</div>
          </a>
        )}
      </div>
      {title?.length > 0 && <h3>{title}</h3>}
    </div>
  );
};

Badge.propTypes = {
  title: PropTypes.string,
  badgeImg: PropTypes.string.isRequired,
  status: PropTypes.bool,
  lockLinkUrl: PropTypes.string,
  onClick: PropTypes.func,
};

export default Badge;
